import {isNil} from 'ramda';

import {RentalPriceGroupItemResponseBody} from '@dms/api/vehicle';

import {Nullish} from 'shared/web';

export const getShouldShowInvalidRangeWarning = (
  activePriceGroupItem: RentalPriceGroupItemResponseBody | Nullish,
  paidDays: number | Nullish
) => {
  if (isNil(activePriceGroupItem) || isNil(paidDays)) {
    return false;
  }

  if (activePriceGroupItem.range.period === 'day') {
    return paidDays > activePriceGroupItem.range.to || paidDays < activePriceGroupItem.range.from;
  }

  return paidDays > activePriceGroupItem.range.to || paidDays < activePriceGroupItem.range.from;
};
